import CommonAction from '../../shared/Http/Http';
import {DEFAULT_OPTIONS_GET, DEFAULT_OPTIONS_EDIT} from '../constants';

export const getDefaultOptions = (globalType,provider) => CommonAction('GET', null, `backoffice-extended/settings/get/?globalType=${globalType}&provider=${provider}`, DEFAULT_OPTIONS_GET, null);
export const editDefaultOptions = (body) => CommonAction('PUT', null, `backoffice-extended/settings/edit`,  DEFAULT_OPTIONS_EDIT, body);